import { render } from "./SkillsComponent.vue?vue&type=template&id=60ac2d5e"
import script from "./SkillsComponent.vue?vue&type=script&lang=js"
export * from "./SkillsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__